export const classLevels = [
	{ label: "Maternelle", value: 12 },
	{ label: "CP", value: 11 },
	{ label: "CE1", value: 10 },
	{ label: "CE2", value: 9 },
	{ label: "CM1", value: 8 },
	{ label: "CM2", value: 7 },
	{ label: "6ème", value: 6 },
	{ label: "5ème", value: 5 },
	{ label: "4ème", value: 4 },
	{ label: "3ème", value: 3 },
	{ label: "2nde", value: 2 },
	{ label: "1ère", value: 1 },
	{ label: "Terminale", value: 0 },
	{ label: "Licence 1", value: -1 },
	{ label: "Licence 2", value: -2 },
	{ label: "Licence 3", value: -3 },
	{ label: "Master 1", value: -4 },
	{ label: "Master 2", value: -5 },
	{ label: "Vie active", value: -6 },
	{ label: "Retraité", value: -7 },
] as const;

export type ClassLevel = typeof classLevels[number];